// import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// // Login Redux States
// import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
// import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

// //Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper";
// import {
//   postFakeLogin,
//   postJwtLogin,
//   postSocialLogin,
// } from "../../../helpers/fakebackend_helper";

// const fireBaseBackend = getFirebaseBackend();

// function* loginUser({ payload: { user, history } }) {
//   try {
//     // if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//     //   const response = yield call(
//     //     fireBaseBackend.loginUser,
//     //     user.email,
//     //     user.password
//     //   );
//     //   yield put(loginSuccess(response));
//     // } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//     //   const response = yield call(postJwtLogin, {
//     //     email: user.email,
//     //     password: user.password,
//     //   });
//     //   localStorage.setItem("authUser_"+api, JSON.stringify(response));
//     //   yield put(loginSuccess(response));
//     // } else
//     if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
//       const response = yield call(postFakeLogin, {
//         email: user.email,
//         password: user.password,
//       });
//       console.log("response", response);
//       localStorage.setItem("authUser_"+api, JSON.stringify(response));
//       yield put(loginSuccess(response));
//     }
//     history('/dashboard');
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }

// function* logoutUser({ payload: { history } }) {
//   try {
//     localStorage.removeItem("authUser_"+api);

//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const response = yield call(fireBaseBackend.logout);
//       yield put(logoutUserSuccess(response));
//     }
//     history('/login');
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }

// function* socialLogin({ payload: { type, history } }) {
//   try {
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const fireBaseBackend = getFirebaseBackend();
//       const response = yield call(fireBaseBackend.socialLoginUser, type);
//       if (response) {
//         history("/dashboard");
//       } else {
//         history("/login");
//       }
//       localStorage.setItem("authUser_"+api, JSON.stringify(response));
//       yield put(loginSuccess(response));
//     }
//     if(response)
//     history("/dashboard");
//   } catch (error) {
//     console.log("error",error)
//     yield put(apiError(error));
//   }
// }

// function* authSaga() {
//   yield takeEvery(LOGIN_USER, loginUser);
//   yield takeLatest(SOCIAL_LOGIN, socialLogin);
//   yield takeEvery(LOGOUT_USER, logoutUser);
// }

// export default authSaga;
// actions/types.js
// sagas/authSaga.js
import { takeLatest, put } from "redux-saga/effects";
import { LOGIN_REQUEST, LOGOUT_USER } from "./actionTypes";
import { loginSuccess, loginFailure } from "./actions";
import axios from "axios";
import Config from "config";
const backUrl = Config.backOffice.url;
const api = Config.backOffice.apiName;
function* login(action) {
  const { login, history } = action.payload;

  try {
    const response = yield axios.post(
      `https://www.fluxod.com/${api}/authenticate`,
      {
        login: btoa(login.login),
        password: btoa(login.password),
      }
    );
    console.log(response);
    // Stocker le token dans local storage
    localStorage.setItem("auth_token_" + api, response.data.auth_token);
    localStorage.setItem("authUser_" + api, response.data.sil);
    const sidebar = JSON.stringify(response.data.menu);
    localStorage.setItem("sideBar_" + api, sidebar);
    localStorage.setItem("typeDeCompte_" + api, response.data.type_compte);
    yield put(loginSuccess(response.data.auth_token, response.data.menu));
    const previousPath = localStorage.getItem("previousPath_" + api);
    if (
      previousPath?.includes("login") ||
      previousPath?.includes("logout") ||
      previousPath == null
    ) {
      history(`${backUrl}/fdashboards`);
    } else {
      history(`${previousPath}`);
    }
  } catch (error) {
    console.log("error", error);
    yield put(loginFailure(error.response.data.error));
  }
}
function* logout({ payload: { history } }) {
  localStorage.removeItem("auth_token_" + api);
  localStorage.removeItem("authUser_" + api);
  localStorage.removeItem("sideBar_" + api);
  localStorage.removeItem("typeDeCompte_" + api);
  localStorage.removeItem("leftSideBar");
  localStorage.removeItem("screen");
  localStorage.removeItem("key");
  localStorage.removeItem("layoutMode");
  history(`${backUrl}/login`);
}

function* authSaga() {
  yield takeLatest(LOGIN_REQUEST, login);
  yield takeLatest(LOGOUT_USER, logout);
}

export default authSaga;
